export default __webpack_public_path__ + "static/media/verify.02802cb4.png";